import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, CheckCircle2, XCircle } from 'lucide-react';
import { absUrl } from '../lib/api';

const positionCategory = (pos) => {
  const p = (pos || '').toLowerCase();
  if (p.includes('keeper')) return 'pos-badge-goalkeeper';
  if (p.includes('back') || p.includes('centre back') || p.includes('center back')) return 'pos-badge-defender';
  if (p.includes('winger')) return 'pos-badge-winger';
  if (p.includes('striker') || p.includes('forward')) return 'pos-badge-forward';
  if (p.includes('mid')) return 'pos-badge-midfielder';
  return 'pos-badge-midfielder';
};

export default function PlayerCard({ player }) {
  return (
    <Link
      to={`/player/${player.id}`}
      className="mft-card group block bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm mft-fade-in relative"
    >
      <div className="relative aspect-[4/3] bg-gray-100 overflow-hidden">
        {player.profile_picture ? (
          <img
            src={absUrl(player.profile_picture)}
            alt={player.full_name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300 text-xl">No photo</div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute top-3 right-3">
          {player.available_for_offers ? (
            <span className="bg-emerald-500 text-white text-[11px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-md">
              <CheckCircle2 className="w-3.5 h-3.5" /> Available
            </span>
          ) : (
            <span className="bg-gray-700 text-white text-[11px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-md">
              <XCircle className="w-3.5 h-3.5" /> Not available
            </span>
          )}
        </div>
        <div className="absolute top-3 left-3">
          <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full shadow-md ${positionCategory(player.position)}`}>
            {player.position}
          </span>
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h3 className="font-black text-gray-900 text-base leading-tight">{player.full_name}</h3>
            {player.nickname ? (
              <p className="text-sm text-[color:var(--mft-green)] italic font-medium">"{player.nickname}"</p>
            ) : null}
          </div>
        </div>

        <div className="mt-3 flex items-center gap-3 text-xs">
          <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-2 py-1 rounded-full font-medium">
            <Calendar className="w-3.5 h-3.5" /> {player.age} yrs
          </span>
          <span className="inline-flex items-center gap-1 bg-[color:var(--mft-sky)] text-[color:var(--mft-green)] px-2 py-1 rounded-full font-medium">
            <MapPin className="w-3.5 h-3.5" /> {player.province}
          </span>
        </div>

        {player.bio && <p className="mt-3 text-sm text-gray-600 line-clamp-2">{player.bio}</p>}
      </div>
    </Link>
  );
}
